
import $ from 'jquery';
import _ from 'lodash';
import Spinner              from 'spin/spin';
import constants            from 'Constants.js';
import configService        from 'ConfigService';
import restService          from 'RestService.js';

class RestMobileService {

    constructor() {

        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });

    }

    getView( formId, formVersionId, type) {
        const formData = new FormData();
        formData.append("token", restService.getToken());
        formData.append("formId", formId);
        formData.append("formVersionId", formVersionId);
        formData.append("type", type);

        let formsRequestObject = {
            url: this.apiHostUrl + '/App/GetView',
            data: formData,
            processData: false,
            contentType: false,
            method: 'POST'
        };
        let settings = restService.getSettings(formsRequestObject);
        const url = this.apiHostUrl + '/App/GetView',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        let promise = new Promise((resolve, reject) => {
            let self = this;
            const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE'),
                    payLoad = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(payLoad);
                    restService.setToken(response.RESULT.TOKEN);
                } else {
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(()=>{
                spinner.stop();
            });
        });

        return promise;

    }

    openMobileForm (formId, majorVersion, minorVersion, mobileViewTypeId) {
        const postParams = {
            token: restService.getToken(),
            formId: formId,
            majorVersion: majorVersion,
            minorVersion: minorVersion,
            mobileViewTypeId: mobileViewTypeId,
            dataType: 'JSON'
        }
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const url = this.apiHostUrl + '/App/GetMobileForm';
        let promise = new Promise((resolve, reject) => {
            $.get(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE'),
                    payLoad = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(payLoad);
                    restService.setToken(response.RESULT.TOKEN);
                } else {
                    reject(error);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(()=>{
                spinner.stop();
            });
        });
        return promise;
    }

}
const restMobileService = new RestMobileService();
export default restMobileService;